import React, {useRef, useState, useLayoutEffect} from 'react'
import {Trans, useTranslation} from 'react-i18next'
import {Typography} from 'antd'
import OpportunityImg1 from '~/assets/img/digital-receipts/opportunity_img_1_1.svg'
import OpportunityImg2 from '~/assets/img/digital-receipts/opportunity_img_2.png'
import OpportunityImg3 from '~/assets/img/digital-receipts/opportunity_img_3_1.svg'

import styles from './styles.scss'

export const MarketingOpportunities = () => {
    const {t, i18n} = useTranslation()
    const titleRefs = useRef<Array<HTMLDivElement | null>>([])
    const [maxTitleHeight, setMaxTitleHeight] = useState(0)

    const opportunities = [
        {
            title: (
                <Trans
                    i18nKey='MarketingOpportunities.card1.title'
                    components={{
                        br: <br />,
                        highlight: <span className={styles.highlight} />,
                        last: <span className={styles.lastWord} />
                    }}
                />
            ),
            image: OpportunityImg1,
            description: t('MarketingOpportunities.card1.description')
        },
        {
            title: (
                <Trans
                    i18nKey='MarketingOpportunities.card2.title'
                    components={{
                        br: <br />,
                        highlight: <span className={styles.highlight} />,
                        last: <span className={styles.lastWord} />
                    }}
                />
            ),
            image: OpportunityImg2,
            description: t('MarketingOpportunities.card2.description')
        },
        {
            title: (
                <Trans
                    i18nKey='MarketingOpportunities.card3.title'
                    components={{
                        br: <br />,
                        highlight: <span className={styles.highlight} />,
                        last: <span className={styles.lastWord} />
                    }}
                />
            ),
            image: OpportunityImg3,
            description: t('MarketingOpportunities.card3.description')
        }
    ]

    useLayoutEffect(() => {
        let frame1 = 0
        let frame2 = 0

        const calculateMaxHeight = () => {
            const heights = titleRefs.current.map((el) => el?.getBoundingClientRect().height || 0)
            const maxHeight = Math.max(...heights, 0)
            setMaxTitleHeight(maxHeight)
        }

        const measure = () => {
            frame1 = requestAnimationFrame(() => {
                frame2 = requestAnimationFrame(() => {
                    calculateMaxHeight()
                })
            })
        }

        measure()

        if (document.fonts?.ready) {
            document.fonts.ready.then(measure)
        }

        window.addEventListener('resize', measure)

        return () => {
            cancelAnimationFrame(frame1)
            cancelAnimationFrame(frame2)
            window.removeEventListener('resize', measure)
        }
    }, [i18n.language])

    return (
        <div className={styles.section}>
            <Typography.Title className={styles.sectionTitle}>
                {t('MarketingOpportunities.title')}
            </Typography.Title>

            <div className={styles.root}>
                <div className={styles.holder}>
                    {opportunities.map(({title, image, description}, index) => (
                        <div className={styles.card} key={index}>
                            <div
                                ref={(el) => {
                                    titleRefs.current[index] = el
                                }}
                                className={styles.titleWrap}
                                style={{height: maxTitleHeight ? `${maxTitleHeight}px` : 'auto'}}
                            >
                                <Typography.Title className={styles.title}>
                                    {title}
                                </Typography.Title>
                            </div>

                            <img src={image} className={styles.image} alt='' />

                            <Typography.Paragraph className={styles.description}>
                                {description}
                            </Typography.Paragraph>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
